<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      justify="center"
      class="mx-0"
    >
      <v-col
        cols="12"
        sm="12"
        class="text-center"
      >
        <img
          src="@/assets/logo.svg"
          height="100"
        >
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
        xl="4"
      >
        <div
          v-if="urlLogin && loading"
          class="full-width text-center"
        >
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          />
        </div>
        <material-card
          v-else-if="!urlLogin"
          class="mt-0"
          :loading="loading"
          color="primary"
          :title="'Login'"
        >
          <material-notification
            v-if="error"
            class="mb-3"
            color="error"
            icon="mdi-information-outline"
          >
            {{ error }}
          </material-notification>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent
            @keyup.enter.native="submit"
          >
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="email"
                    label="Email Address"
                    :rules="emailRules"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    label="Password"
                    :type="show ? 'text' : 'password'"
                    :rules="passwordRules"
                    @click:append="show = !show"
                  />
                </v-col>
                <v-col
                  cols="12"
                  class="text-right"
                >
                  <!-- <v-btn
                    outlined
                    color="primary"
                    class="mr-2"
                    @click="register"
                  >
                    Register
                  </v-btn> -->
                  <v-btn
                    color="primary"
                    :loading="loading"
                    @click="submit"
                  >
                    Login
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import paths from '../router/paths.js'
  export default {
    data () {
      return {
        error: false,
        valid: false,
        loading: false,
        show: false,
        urlLogin: false,
        email: '',
        token: '',
        password: '',
        passwordRules: [
          v => !!v || 'Password is required'
        ],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid',
        ]
      }
    },
    watch: {
      '$route.query.redirect' (value) {
        if (this.$route.query.redirect && this.$route.query.redirect !== '/') {
          this.error = 'You need to be logged in to view this page'
        }
      }
    },
    created () {
      var logout = this.$route.query.logout
      if (logout) {
        this.logout()
      }
      var token = this.$route.query.token
      var email = this.$route.query.email
      var verify = this.$route.query.verify
      if (token && email) {
        this.email = email
        this.token = token
        this.urlLogin = true
        this.login({
          email,
          token,
        }, verify)
      }
    },
    methods: {
      register () {
        this.$router.push('/register?redirect=', this.getRedirect())
      },
      submit () {
        if (this.$refs.form.validate()) {
          if (this.token) {
            this.login({
              email: this.email,
              token: this.token,
            })
          } else {
            this.login({
              email: this.email,
              password: this.password,
            })
          }
        }
      },
      getRedirect (user) {
        if (this.$route.query.redirect && this.$route.query.redirect !== '/login' && this.$route.query.redirect !== '/register') {
          return this.$route.query.redirect
        } else {
          var role = user.role.toLowerCase()
          if (!role) {
            role = 'default'
          }
          return paths.find(path => path.roles && path.roles.indexOf(role.toLowerCase()) > -1).path
        }
      },
      logout () {
        this.api.defaults.headers.Authorization = ''
        localStorage.removeItem('claim')
        this.$store.commit('setUser', null)
        this.$store.commit('setSite', null)
        this.$store.commit('setSites', [])
      },
      login (body) {
        this.loading = true
        this.api.post('user/login', body)
          .then(result => {
            this.loading = false
            this.$store.commit('setUser', result.data)
            localStorage.setItem('claim', JSON.stringify(result.data))
            this.api.defaults.headers.Authorization = 'Bearer ' + result.data.token

            this.$router.push(this.getRedirect(result.data))
          }, error => {
            this.loading = false
            this.urlLogin = false
            this.error = error
          })
      }
    }
  }
</script>
